// Mock data for Aventa Rekonstrukce clone (frontend only)

import {
  Home,
  Bath,
  ChefHat,
  Cable,
  Layers,
  LayoutDashboard,
  PencilRuler,
} from "lucide-react";

import sluzbaKompletni from "./assets/sluzba-kompletni.webp";
import sluzbaKoupelna from "./assets/sluzba-koupelna.webp";
import sluzbaKuchyne from "./assets/sluzba-kuchyne.webp";
import sluzbaRozvody from "./assets/sluzba-rozvody.webp";
import sluzbaDispozice from "./assets/sluzba-dispozice.png";
import sluzbaGraficke from "./assets/sluzba-graficke.jpg";

export const IMAGES = {
  heroInterior:
    "https://images.pexels.com/photos/35419422/pexels-photo-35419422.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  heroFloorplan:
    "https://images.pexels.com/photos/8962803/pexels-photo-8962803.jpeg",
  aboutRoom:
    "https://images.pexels.com/photos/19966766/pexels-photo-19966766.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const NAV_LINKS = [
  { label: "Služby", href: "#sluzby" },
  { label: "Rekonstrukce", href: "#prace" },
  { label: "Kalkulačka", href: "#kalkulacka" },
  { label: "Proces", href: "#proces" },
  { label: "Kontakt", href: "#kontakt" },
];

export const SERVICES = [
  {
    icon: Home,
    title: "Kompletní rekonstrukce na klíč",
    desc: "Kompletní rekonstrukce bytu či domu bez starostí.",
    image: sluzbaKompletni,
    points: [
      "Jeden dodavatel pro vše",
      "Vlastní stavební tým",
      "Realizace do 2 měsíců",
    ],
  },
  {
    icon: Bath,
    title: "Koupelna na klíč",
    desc: "Návrh i realizace koupelny od A do Z.",
    image:
      "https://images.pexels.com/photos/7587747/pexels-photo-7587747.jpeg",
    points: [
      "Obklady a dlažby",
      "Sprchové kouty a vany",
      "Sanita a baterie",
      "Osvětlení a topné žebříky",
    ],
  },
  {
    icon: ChefHat,
    title: "Kuchyně na míru",
    desc: "Kuchyně na míru včetně spotřebičů a osvětlení.",
    image: sluzbaKuchyne,
    points: [
      "Kuchyňské linky na míru",
      "Pracovní desky a obklady",
      "Vestavné spotřebiče",
      "Osvětlení a úložné prostory",
    ],
  },
  {
    icon: Cable,
    title: "Rozvody vody a elektřiny",
    desc: "Kompletní nové rozvody vody, odpadů a elektroinstalace.",
    image: sluzbaRozvody,
    points: [
      "Nové rozvody studené a teplé vody",
      "Odpady a kanalizace",
      "Silnoproudé i slaboproudé elektroinstalace",
      "Rozvaděče a revizní zprávy",
    ],
  },
  {
    icon: Layers,
    title: "Nové podlahy a omítky",
    desc: "Nové podlahy, sádrové omítky, štuky a malby.",
    image:
      "https://images.unsplash.com/photo-1630699376106-d550afb865bd?auto=format&fit=crop&w=940&q=80",
    points: [
      "Dřevěné a vinylové podlahy",
      "Velkoformátová dlažba",
      "Sádrové omítky a štuky",
      "Malby a dekorativní povrchy",
    ],
  },
  {
    icon: LayoutDashboard,
    title: "Změny dispozice",
    desc: "Přeměníme dispozice bytu i domu k lepšímu.",
    image: sluzbaDispozice,
    fit: "contain",
    points: [
      "Návrh nové dispozice",
      "Bourací práce",
      "Nové příčky a otvory",
      "Statické posouzení a dokumentace",
    ],
  },
  {
    icon: PencilRuler,
    title: "Grafické návrhy",
    desc: "Vlastní oddělení návrhů a 3D vizualizací.",
    image: sluzbaGraficke,
    points: [
      "Dispoziční studie",
      "3D vizualizace interiéru",
      "Výběr materiálů a barev",
      "Kompletní projektová dokumentace",
    ],
  },
];

export const VIDEOS = [
  {
    title: "Videoprohlídka bytu 3+kk",
    poster: sluzbaKuchyne,
    videoSrc: "/videos/videoprohlidka-3kk.mp4",
  },
  {
    title: "Videoprohlídka 3+kk, 60 m² s balkonem, šatnou a komorou",
    poster: sluzbaKoupelna,
    videoSrc: "/videos/videoprohlidka-3kk-balkon.mp4",
  },
];

export const PROCESS_STEPS = [
  {
    num: "01",
    title: "Konzultace a zaměření",
    desc: "Osobní schůzka, zaměření prostoru a pochopení vašich představ.",
  },
  {
    num: "02",
    title: "Grafický a dispoziční návrh",
    desc: "Naše oddělení návrhů připraví vizualizace a novou dispozici.",
  },
  {
    num: "03",
    title: "Cenová nabídka",
    desc: "Transparentní rozpočet a harmonogram prací bez skrytých položek.",
  },
  {
    num: "04",
    title: "Realizace do 2 měsíců",
    desc: "Vlastní stavební tým provede rekonstrukci ve standardu i nadstandardu.",
  },
  {
    num: "05",
    title: "Předání hotového díla",
    desc: "Úklid, kontrola detailů a předání klíčů od nového domova.",
  },
];

// Calculator config: price per m2 in CZK
export const CALC_TYPES = [
  { id: "byt", label: "Byt", standard: 15000, nadstandard: 20000, unit: "m²", areaLabel: "Plocha (m²)", placeholder: "např. 65", note: "Cena bytu je uvedena včetně kuchyňské linky." },
  { id: "dum", label: "Dům", standard: 15000, nadstandard: 20000, unit: "m²", areaLabel: "Plocha (m²)", placeholder: "např. 120", note: "Cena zahrnuje kompletní rekonstrukci domu." },
  { id: "koupelna", label: "Koupelna", standard: 15000, nadstandard: 20000, unit: "m²", areaLabel: "m² podlahy koupelny", placeholder: "např. 6", note: "Cena koupelny na klíč včetně obkladů a sanity." },
  { id: "kuchyne", label: "Kuchyně", standard: 15000, nadstandard: 20000, unit: "bm", areaLabel: "Běžný metr (bm)", placeholder: "např. 4", note: "Cena kuchyně na míru včetně spotřebičů." },
];

export const CONTACT = {
  phone: "+420 777 796 222",
  email: "slavik@aventareality.cz",
  city: "Plzeň, Česká republika",
  company: "Aventa reality s.r.o.",
  ico: "24039675",
  address: "Pod Hůrkou 6, Plzeň, 321 00",
  web: "aventarekonstrukce.cz",
};
